import { render } from "./FormAlt.vue?vue&type=template&id=a634d2cc&scoped=true"
import script from "./FormAlt.vue?vue&type=script&lang=js"
export * from "./FormAlt.vue?vue&type=script&lang=js"

import "./FormAlt.vue?vue&type=style&index=0&id=a634d2cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a634d2cc"

export default script